import type { ReportSlideKind } from '@shared/models/report-slides.model';

/**
 * Whether {@link kind} is currently hidden on a version or proposal.
 */
export const isReportSlideHidden = <T extends ReportSlideKind>(
  hidden: readonly T[] | undefined,
  kind: T,
): boolean => Boolean(hidden?.includes(kind));

/**
 * Next hidden-slides list after showing or hiding {@link kind}.
 */
export const withReportSlideHidden = <T extends ReportSlideKind>(
  hidden: readonly T[] | undefined,
  kind: T,
  nextHidden: boolean,
): T[] => {
  const current = hidden ?? [];
  if (nextHidden) {
    if (current.includes(kind)) return [...current];
    return [...current, kind];
  }
  return current.filter((item) => item !== kind);
};
